<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  name: {
    type: String,
    default: () => ''
  },
  text: {
    type: String,
    default: () => ''
  },
  value: {
    type: [String, Number],
    default: () => ''
  },
  img: {
    type: String,
    default: () => ''
  },
  modelValue: {
    type: [String, Number],
    default: () => ''
  },
  variant: {
    type: String,
    default: 'image-text'
  }
});

const emit = defineEmits(['update:modelValue']);

const handleInputChange = () => {
  emit('update:modelValue', props.value);
};

const handleLabelClick = () => {
  if (String(props.modelValue) === String(props.value)) {
    emit('update:modelValue', props.value);
  }
};
</script>

<template>
  <label
      class="radio-button"
      :class="[`radio-button--${variant}`, { '_checked': String(modelValue) === String(value) }]"
      @click="handleLabelClick"
  >
    <input
        type="radio"
        :name="name"
        :value="value"
        :checked="String(modelValue) === String(value)"
        @change="handleInputChange"
    >
    <span class="radio-button__content">
          <span v-if="img" class="radio-button__image">
            <img :src="img" alt="">
          </span>
          <span class="radio-button__text">
            <p v-html="text" />
          </span>
        </span>
  </label>
</template>
